export { default } from './Onboarding';
